import { render, staticRenderFns } from "./ImportLogList.vue?vue&type=template&id=1243190a&scoped=true&"
import script from "./ImportLogList.vue?vue&type=script&lang=js&"
export * from "./ImportLogList.vue?vue&type=script&lang=js&"
import style0 from "./ImportLogList.vue?vue&type=style&index=0&id=1243190a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1243190a",
  null
  
)

component.options.__file = "ImportLogList.vue"
export default component.exports